import { useState } from "react";
import { animationsEnabled } from "./MotionControl";

const PARTICLES = 10;
const BURST_MS = 450;
const COLORS = ["#f59e0b", "#0ea5e9", "#10b981", "#ef4444", "#8b5cf6"];

// Checkbox that bursts when a todo is completed. Completing a todo removes
// its row from the list straight away, which would cut the animation off, so
// the toggle is held back for the length of the burst (only when animations
// are on; otherwise it fires immediately).
export const CompleteCheckbox = ({
  checked,
  onToggle,
}: {
  checked: boolean;
  onToggle: () => void;
}) => {
  const [bursting, setBursting] = useState(false);

  const handleChange = () => {
    if (checked || bursting || !animationsEnabled()) {
      onToggle();
      return;
    }
    setBursting(true);
    setTimeout(() => {
      onToggle();
      setBursting(false);
    }, BURST_MS);
  };

  return (
    <label className="relative inline-flex items-center justify-center min-h-10 min-w-10 -my-2 -mx-2 sm:m-0 sm:min-h-0 sm:min-w-0">
      <input type="checkbox" checked={checked || bursting} onChange={handleChange} />
      {bursting && (
        <span aria-hidden className="todo-burst">
          {Array.from({ length: PARTICLES }, (_, i) => {
            const angle = (i / PARTICLES) * 2 * Math.PI;
            return (
              <span
                key={i}
                style={
                  {
                    "--dx": `${Math.cos(angle) * 28}px`,
                    "--dy": `${Math.sin(angle) * 28}px`,
                    background: COLORS[i % COLORS.length],
                  } as React.CSSProperties
                }
              />
            );
          })}
        </span>
      )}
    </label>
  );
};
